export const appConfig = {
    domain: 'wayland.app',
    analyticsDomain: 'https://wayland.app',
}
